export function isOtherValueField(value: string) {
  return /^OTHER/.test(value);
}
